module.exports = __webpack_public_path__ + "public/img/ico-chart-euro.e58038f7.svg";